import { AfterViewInit, Component, HostListener, OnInit } from '@angular/core';
import { AuthenticationService } from '@app/security/authentication.service';
import { JengaError } from '@app/types/error';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { UserService } from '@data/services/user.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalMessageService } from '@shared/services/global-message.service';
import { NGXLogger } from 'ngx-logger';
import UserDTO from '@data/models/user/user-dto';

@Component({
  selector: 'app-administration-layout',
  templateUrl: './administration-layout.component.html',
  styleUrls: ['./administration-layout.component.scss']
})
export class AdministrationLayoutComponent implements OnInit {
  public filterDrawerDisableClose = false;
  public userDetails: UserDTO;

  constructor(
    private userService: UserService,
    private logger: NGXLogger,
    private translateService: TranslateService,
    private globalMessageService: GlobalMessageService,
    private authenticationService: AuthenticationService
  ) {}

  ngOnInit(): void {}

  public getUserDetails(): void {
    const userId = this.authenticationService.getUserId();
    this.userDetails = this.userService.userLogged$.value;
    if (!this.userDetails) {
      this.userService.getUserDetailsById(userId).subscribe({
        next: (response) => {
          this.userDetails = response;
          this.userService.userLogged$.next(response);
        },
        error: (error: JengaError) => {
          this.logger.error(error);
          this.globalMessageService.showError({
            message: error.message,
            actionText: this.translateService.instant(marker('common.close'))
          });
        }
      });
    }
  }
}
